import { render, staticRenderFns } from "./GeneratePresentations.vue?vue&type=template&id=42da07fa&"
import script from "./GeneratePresentations.vue?vue&type=script&lang=js&"
export * from "./GeneratePresentations.vue?vue&type=script&lang=js&"
import style0 from "./GeneratePresentations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VSpacer})
